'use client';
import React, { useState } from 'react';
import AppLayout from '@/components/AppLayout';
import AdminHeader from './components/AdminHeader';
import AdminKPIs from './components/AdminKPIs';
import AdminCreatorTable from './components/AdminCreatorTable';
import PendingVerifications from './components/PendingVerifications';
import AdminBrandAccounts from './components/AdminBrandAccounts';
import AdminActivityLog from './components/AdminActivityLog';
import Icon from '@/components/ui/AppIcon';

const ACCESS_CODE = '0551';

export default function AdminPanelPage() {
  const [code, setCode] = useState('');
  const [unlocked, setUnlocked] = useState(false);
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code === ACCESS_CODE) {
      setUnlocked(true);
      setError(false);
    } else {
      setError(true);
      setShake(true);
      setCode('');
      setTimeout(() => setShake(false), 600);
    }
  };

  if (!unlocked) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className={`bg-card border border-border rounded-2xl p-8 w-full max-w-sm shadow-2xl ${shake ? 'animate-shake' : ''}`}>
          <div className="flex flex-col items-center mb-8">
            <div className="w-16 h-16 rounded-2xl bg-primary/10 border border-primary/20 flex items-center justify-center mb-4">
              <Icon name="LockClosedIcon" size={28} className="text-primary" />
            </div>
            <h1 className="text-xl font-700 text-foreground">Admin Panel</h1>
            <p className="text-sm text-muted-foreground mt-1 text-center">360 Creator Index · Accès restreint</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-600 text-muted-foreground uppercase tracking-wide mb-2">
                Code d'accès
              </label>
              <input
                type="password"
                value={code}
                onChange={(e) => { setCode(e.target.value); setError(false); }}
                placeholder="••••"
                maxLength={10}
                autoFocus
                className={`w-full bg-muted border rounded-xl px-4 py-3 text-center text-2xl font-700 tracking-widest text-foreground outline-none transition-all ${
                  error ? 'border-negative focus:border-negative' : 'border-border focus:border-primary'
                }`}
              />
              {error && (
                <p className="text-xs text-negative font-600 text-center mt-2">Code incorrect. Réessayez.</p>
              )}
            </div>
            <button
              type="submit"
              className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-700 py-3 rounded-xl transition-all active:scale-95 text-sm"
            >
              Accéder au panel
            </button>
          </form>
        </div>
        <style jsx>{`
          @keyframes shake {
            0%, 100% { transform: translateX(0); }
            20% { transform: translateX(-8px); }
            40% { transform: translateX(8px); }
            60% { transform: translateX(-6px); }
            80% { transform: translateX(6px); }
          }
          .animate-shake { animation: shake 0.5s ease-in-out; }
        `}</style>
      </div>
    );
  }

  return (
    <AppLayout currentPath="/admin-panel">
      <div className="space-y-8">
        <AdminHeader />
        <AdminKPIs />
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          <div className="xl:col-span-2 space-y-6">
            <AdminCreatorTable />
            <AdminBrandAccounts />
          </div>
          <div className="space-y-6">
            <PendingVerifications />
            <AdminActivityLog />
          </div>
        </div>
      </div>
    </AppLayout>
  );
}